// The API's limits are in bytes, so a multi-byte character counts for more than one.
export const MIN_PASSWORD_BYTES = 12;
export const MAX_PASSWORD_BYTES = 1024;

export function passwordBytes(password: string) {
  return new TextEncoder().encode(password).length;
}

export function passwordProblem(password: string): string | undefined {
  const bytes = passwordBytes(password);
  if (bytes >= MIN_PASSWORD_BYTES && bytes <= MAX_PASSWORD_BYTES) return undefined;
  return `must be ${MIN_PASSWORD_BYTES} to ${MAX_PASSWORD_BYTES} bytes (now ${bytes})`;
}
